/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs */

const en_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot offers manual and automatic ways to check members into your space.`)
};

const de_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot bietet vier verschiedene Wege zum Einchecken von Mitgliedern an.`)
};

const es_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot te ofrece cuatro maneras de hacer el check-in de miembros en tu espacio.`)
};

const fr_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot vous offre quatre possibilités différentes pour enregistrer vos membres dans votre espace.`)
};

const nl_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot biedt handmatige en automatische manieren om leden in te checken in je Space.`)
};

const it_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot offre modi manuali e automatici per registrare i membri nel tuo spazio.`)
};

const pt_br2_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot oferece maneiras manuais e automáticas para membros fazerem check-in no seu espaço.`)
};

const pl_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot oferuje cztery różne sposoby zameldowania członków w twojej przestrzeni.`)
};

const hu_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Cobotban négyféle módon jelentkezhetnek be a tagok a helyre.`)
};

const ro_admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {(inputs: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot ofera modalitati manuale si automate de a inregistra membrii in spatiul dumneavoastra.`)
};

/**
* | output |
* | --- |
* | "Cobot offers manual and automatic ways to check members into your space." |
*
* @param {Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_cobot_offers_different_ways_to_check_in = /** @type {((inputs?: Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Cobot_Offers_Different_Ways_To_Check_InInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "de") return de_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "es") return es_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "fr") return fr_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "nl") return nl_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "it") return it_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "pl") return pl_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	if (locale === "hu") return hu_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
	return ro_admin_dashboard_cobot_offers_different_ways_to_check_in(inputs)
});
export { admin_dashboard_cobot_offers_different_ways_to_check_in as "admin.dashboard.cobot_offers_different_ways_to_check_in" }